import styled from 'styled-components';
import { Absolute, Box, Text } from '@rsos/components/capstone/base';
import TileDark from './assets/tile-dark.webp';
import TileLight from './assets/tile-light.webp';
import TileSatellite from './assets/tile-satellite.jpg';
import { fadeIn, fadeOut } from './fadeAnimations.styles';

const BASEMAP_TILE_WIDTH = 72;

const BASEMAP_TILE_HEIGHT = BASEMAP_TILE_WIDTH;

const BASEMAP_GAP = 16;

export const BasemapMenuPosition = styled(Absolute).attrs({
  bottom: 32,
  left: 16,
  zIndex: 2,
})``;

export const BasemapGap = styled(Box).attrs({
  position: 'absolute',
  width: `${BASEMAP_GAP}px`,
  height: `${BASEMAP_TILE_HEIGHT}px`,
})`
  // The white space to the right of the basemap button.
  left: ${BASEMAP_TILE_WIDTH}px;

  // This component is only visible when the basemap button is hovered.
  ${fadeOut};
`;

export const MenuContainer = styled(Box).attrs({
  horizontal: true,
  position: 'absolute',
  backgroundColor: 'background',
  paddingY: '8px',
  borderRadius: '5px',
})`
  cursor: default;
  bottom: 0;

  // Distance between basemap button and container.
  left: ${BASEMAP_TILE_WIDTH + BASEMAP_GAP + 'px'};

  // This component is only visible when the basemap button is hovered.
  ${fadeOut}
`;

export const BasemapMenuContainer = styled(Box).attrs({
  horizontal: true,
  position: 'relative',
  width: `${BASEMAP_TILE_WIDTH}px`,
  height: `${BASEMAP_TILE_HEIGHT}px`,
})`
  &:hover {
    ${BasemapGap},
    ${MenuContainer} {
      ${fadeIn}
    }
  }
`;

export const BasemapTile = styled(Box).attrs({
  align: 'center',
  width: `${BASEMAP_TILE_WIDTH}px`,
  height: `${BASEMAP_TILE_HEIGHT}px`,
  border: '2px solid white',
  borderRadius: '2px',
  overflow: 'hidden',
})`
  background-image: ${({ isSatelliteBasemap, theme }) =>
    `url(${
      isSatelliteBasemap
        ? theme === 'light'
          ? `${TileLight}`
          : `${TileDark}`
        : `${TileSatellite}`
    })`};

  background-position: center center;
  background-size: contain;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, transparent 40%, black 100%);
  }
`;

export const BasemapTileText = styled(Text).attrs({
  color: 'white',
  size: 'small',
  lineHeight: 1,
  textAlign: 'center',
})`
  position: absolute;
  bottom: 5px;
  cursor: pointer;
`;
